var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCanvas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,18H7.382L6.105,20.553a1,1,0,0,0,1.79.894L9.618,18H11v2a1,1,0,0,0,2,0V18h1.382l1.723,3.447a1,1,0,1,0,1.79-.894L16.618,18H21a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1H13V3a1,1,0,0,0-2,0V4H3A1,1,0,0,0,2,5V17A1,1,0,0,0,3,18ZM4,6H20V16H4Zm5,5v2a1,1,0,0,1-2,0V11a1,1,0,0,1,2,0Zm4-1v3a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0Zm4-1v4a1,1,0,0,1-2,0V9a1,1,0,0,1,2,0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvas);
export default __webpack_public_path__ + "static/media/canvas.d4842a6b93fbf333e13cfe6dca3e1d1e.svg";
export { ForwardRef as ReactComponent };